// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.promoter-center[data-v-1a7635bc] { padding: 16px;\n}\r\n", ""]);
// Exports
module.exports = exports;
